import { Form, InputNumber } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { FieldValue } from 'app/components/commons/Hotel/Contacts/FieldView/FieldView';
import { Option, Select } from 'app/components/fields/Select';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { useAdminUser } from 'app/hooks/data/useAdminUser';

import styles from '../General.module.scss';

import { SelectValue } from './SelectValue';

const RULES = [{ required: true }];

const getAdminLabel = (admin: {
  firstName?: string;
  lastName?: string;
  email: string;
}) =>
  admin.firstName && admin.lastName
    ? `${admin.firstName} ${admin.lastName} - ${admin.email}`
    : `${admin.email}`;

export const AdminSettings = () => {
  const { isEditMode } = useContext(ViewEditModeContext);

  const { data: admins } = useAdminUser();

  return (
    <>
      <FormLineLayout
        label="Contact BD or AM"
        isRequired
        rightClassName={styles.selectField}
      >
        <Form.Item name="managerId" rules={isEditMode ? RULES : undefined}>
          {isEditMode ? (
            <Select
              showSearch
              placeholder="Select a contact"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.key.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                option?.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {admins?.map((admin) => (
                <Option
                  title={`${admin.firstName} ${admin.lastName}`}
                  key={admin.email}
                  id={admin.id}
                  value={admin.id}
                >
                  {getAdminLabel(admin)}
                </Option>
              ))}
            </Select>
          ) : (
            <SelectValue
              options={(admins || []).map((admin) => ({
                id: admin.id,
                name: getAdminLabel(admin),
              }))}
            />
          )}
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout
        label="Parent hotel Id"
        rightClassName={styles.numberField}
      >
        <Form.Item name="parentHotelId">
          {isEditMode ? <InputNumber min={1} /> : <FieldValue />}
        </Form.Item>
      </FormLineLayout>
    </>
  );
};
